<template>
  <div>
    <b-select
      v-model="statusId"
      :error-messages="getErrorMessages(v$.statusId)"
      :items="$directory.get('auditRecommendationStatuses')"
      :loading="$loading.isLoading('auditRecommendationStatuses')"
      label="Статус"
      @blur="v$.statusId.$touch()"></b-select>
  </div>
</template>

<script lang="ts">
import { getErrorMessages } from 'best-modules/utils'
import { PropType, ref } from 'vue'
import { Dialog } from '@/dialog'
import { useVuelidate } from '@vuelidate/core'
import { fillDirectory } from '@/directory'
import { required } from '@vuelidate/validators'
import { auditRecommendationSetStatus } from '@/requests/audit'

export default {
  name: 'AuditRecommendationSetStatus',
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: { getErrorMessages },
  setup(props) {
    const statusId = ref<any>(null)

    const rules = { statusId: { required: required } }
    const v$ = useVuelidate(rules, { statusId })

    const submit = () => {
      return auditRecommendationSetStatus(
        props.dialog.dialogData.recommendationId,
        statusId.value
      ).then(res => {
        return res
      })
    }

    fillDirectory('auditRecommendationStatuses')

    return { statusId, v$, submit }
  },
}
</script>

<style lang="scss" scoped></style>
